import cm from 'classnames';

import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { Path, useLocation } from 'components/_hooks/use-router';
import { setStoryModal } from 'components/app/_mediator/app.slice';
import { setSbWsPlayback } from 'components/app/storyboard/_mediator/sb.slice';
import { IntroKeys } from 'components/app/intro/intro-keys';

import { ReactComponent as SettingsIcon } from 'assets/nav-pane/settings.svg';
import { StorySelector } from 'components/app/app-components/story-selector/story-selector';
import { AppButton } from 'components/app/app-components/app-button/app-button';
import { EditorRender } from 'components/app/editor/editor-render/editor-render';
import { EditorBackup } from 'components/app/editor/editor-backup/editor-backup';
import { ActionsAddClip } from './elements/actions-add-clip';
import { ActionsClips } from './elements/actions-clips';
import styles from './_editor-actions.module.scss';

interface Props {
  className?: string;
}

export const EditorActions = ({ className }: Props) => {
  const { path } = useLocation();
  const storyLoaded = useAppSelector((state) => state.app.storyLoaded);
  const sbWsPlayback = useAppSelector((state) => state.sb.sbWsPlayback);
  const dispatch = useAppDispatch();

  if (path === Path.storyboard && sbWsPlayback)
    return (
      <div className={cm(styles.EditorActions)}>
        <AppButton
          outlined
          className={styles.EditorActions__audioStopBtn}
          onClick={() => dispatch(setSbWsPlayback(false))}
        >
          Stop
        </AppButton>
      </div>
    );
  return (
    <div className={cm(styles.EditorActions, className)}>
      <div className={styles.EditorActions__leftCol}>
        <StorySelector />
        <AppButton
          className={styles.EditorActions__settings}
          onClick={() => dispatch(setStoryModal())}
          disabled={!storyLoaded}
          outlined
          tip={storyLoaded ? 'Story Settings' : 'Story is not loaded'}
          tipPosition="bottom"
          data-intro={IntroKeys.sbSettings}
        >
          <SettingsIcon />
        </AppButton>
        <ActionsAddClip />
      </div>
      <div className={styles.EditorActions__centerCol}>
        <ActionsClips />
      </div>
      <div className={styles.EditorActions__rightCol}>
        {path === Path.storyboard && <EditorRender />}
        <EditorBackup />
      </div>
    </div>
  );
};
